import { BaseController, IBaseScope } from "@app/views/base.view";
import { CrudController } from "@app/views/crud.view";
import { events } from "@tools";
import { NgView } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { IKbUserRegister, IDialogService, eAlertType } from "@models";
import { AuthService, IAuthService } from "@app/services/auth.service";
import { IRootScope } from "@models";
import { ApiService } from "../..";

export interface IPrivacyPolicy {
    agreed?: boolean;
}

export interface IPrivacyPolicyScope extends IBaseScope {
    privacyPolicyModel: IPrivacyPolicy;
    agree: () => void;
    logout: () => void;
}

@NgView({
    token: Token.PrivacyPolicyView,
    dependencies: [
        Token.$Scope,
        Token.ApiService,
        Token.$RootScope,
        Token.DialogService,
        Token.AuthService
    ]
})
export class PrivacyPolicyController extends BaseController {
    constructor(
        private $scope: IPrivacyPolicyScope,
        private api: ApiService,
        private $rootScope: IRootScope,
        private dialogService: IDialogService,
        private authService: IAuthService
    ) {

        super();
        $scope.privacyPolicyModel = {};



        $scope.logout = () => {
            authService.logout();
        };

        $scope.agree = () => {
            if (!$scope.privacyPolicyModel.agreed) {
                dialogService.alert({
                    msg: "Before you can continue you must agree to the privacy policy.",
                    type: eAlertType.error,
                    persist: true
                });
                return;
            }
            this.api.users.acceptPrivacyPolicy().then((u) => {
                $rootScope.user.hasLatestPrivacyPolicy = true;
            });
        };
    }
}
